import React from 'react';
import './IOSSpinner.css';

const IOSSpinner = () => {
  return (
    <div className="ios-spinner">
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i}></div>
      ))}
    </div>
  );
};

export default IOSSpinner;
